<template>
<div class="chapter">
<div class="inner_page">
<h2 class="fmTitle2"><a id="h3"></a><a id="page_9"></a>PROLOGUE</h2>
<p class="para">‘We can’t land there!’</p>
<p class="paraNoIndent">‘I think the Queen would understand.’</p>
<p class="para">The fuel gauge had suddenly plummeted towards the empty mark – the only possible site was Windsor Great Park.</p>
<p class="para">Before landing we made a dummy run to warn the strollers of our intention. Just before touchdown I shouted ‘Mind the cakes!’</p>
<p class="para">After rolling to a gentle stop, Eric visually checked the fuel tank, while I inspected the rear locker. The fuel was ample, there was no leak; the Tiger Moth gauge was up to its usual tricks, and the cakes were secure.</p>
<p class="para">We thankfully took off and flew on to our destination, Denham, where, to our great relief, we found the icing on our wedding cakes to be completely undamaged!</p>
<p class="para">An immediate phone call was made to the police in case the bemused onlookers had complained. Two days later we were married and flew away – to another unauthorized landing...</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_prologue.vue?114918dd